import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { Viewer } from "components/auth/types";

import NotFound from "pages/not-found";
import ProfilePage from "./pages/profile";
import ProfileAddressesPage from "./pages/profile/addresses";

type Props = {
  viewer: Viewer
};

const SettingsPage:React.FC<Props> = ({ viewer }) => (
  <Routes>
    <Route path="/" element={<Navigate to="profile" replace />} />
    <Route path="profile" element={<ProfilePage viewer={viewer} />} />
    <Route path="profile/addresses" element={<ProfileAddressesPage viewer={viewer} />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default SettingsPage;
